import Vue from 'vue'
import Papa from 'papaparse'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

let t = null

function sortArray (arr, key, desc) {
  if (typeof arr === 'object') {
    return arr.sort((a, b) => (a[key] > b[key]) ? (desc ? -1 : 1) : ((b[key] > a[key]) ? (desc ? 1 : -1) : 0))
  } else {
    return arr
  }
}

Vue.prototype.$calculateWeightProduct = (d) => {
  d = d ? Object.assign({}, d) : {}
  const wkg = parseFloat(d.weight_kg) || 0
  const vlength = parseFloat(d.weight_length) || 0
  const vwidth = parseFloat(d.weight_width) || 0
  const vheight = parseFloat(d.weight_height) || 0
  const tVolume = vlength * vwidth * vheight
  const tVolumeWeight = tVolume > 0 ? (tVolume / 5000) : 0
  return {
    weight_kg: wkg || 0,
    weight_volume: (tVolumeWeight * 1000) || 0,
    chargeable: Math.max(wkg, tVolumeWeight * 1000) || 0
  }
}

Vue.prototype.$Awb = (shipping) => {
  if (!shipping) {
    return null
  }
  // return (shipping.cabang_code ? (shipping.cabang_code + '-') : '') + (shipping.cabang_destination_code ? (shipping.cabang_destination_code + '-') : '') + (shipping.vendor_code ? (shipping.vendor_code + '-') : '') + (('000000' + (parseInt(shipping.id) || 0)).slice(-6))
  const localDate = new Date(shipping.created)
  const year = localDate.getFullYear().toString()
  const monthNumber = ((localDate.getMonth() + 1) < 10 ? '0' + (localDate.getMonth() + 1) : (localDate.getMonth() + 1))
  return (shipping.cabang_code ? (shipping.cabang_code) : '') + monthNumber + year + (('000000' + (parseInt(shipping.id) || 0)).slice(-6)).toUpperCase()
}

Vue.prototype.$Branch = (shipping) => {
  if (!shipping) {
    return null
  }
  return (shipping.cabang_code ? (shipping.cabang_code) : '') + (('000' + (parseInt(shipping.id) || 0)).slice(-3)).toUpperCase()
}

Vue.prototype.$phoneCode = () => {
  try {
    /* eslint-disable-next-line */
    return JSON.parse(`[{"name":"Afghanistan","dial_code":"+93","code":"AF","country_code":4},{"name":"Aland Islands","dial_code":"+358","code":"AX","country_code":248},{"name":"Albania","dial_code":"+355","code":"AL","country_code":8},{"name":"Algeria","dial_code":"+213","code":"DZ","country_code":12},{"name":"AmericanSamoa","dial_code":"+1684","code":"AS","country_code":16},{"name":"Andorra","dial_code":"+376","code":"AD","country_code":20},{"name":"Angola","dial_code":"+244","code":"AO","country_code":24},{"name":"Anguilla","dial_code":"+1264","code":"AI","country_code":660},{"name":"Antarctica","dial_code":"+672","code":"AQ","country_code":10},{"name":"Antigua and Barbuda","dial_code":"+1268","code":"AG","country_code":28},{"name":"Argentina","dial_code":"+54","code":"AR","country_code":32},{"name":"Armenia","dial_code":"+374","code":"AM","country_code":51},{"name":"Aruba","dial_code":"+297","code":"AW","country_code":533},{"name":"Australia","dial_code":"+61","code":"AU","country_code":36},{"name":"Austria","dial_code":"+43","code":"AT","country_code":40},{"name":"Azerbaijan","dial_code":"+994","code":"AZ","country_code":31},{"name":"Bahamas","dial_code":"+1242","code":"BS","country_code":44},{"name":"Bahrain","dial_code":"+973","code":"BH","country_code":48},{"name":"Bangladesh","dial_code":"+880","code":"BD","country_code":50},{"name":"Barbados","dial_code":"+1246","code":"BB","country_code":52},{"name":"Belarus","dial_code":"+375","code":"BY","country_code":112},{"name":"Belgium","dial_code":"+32","code":"BE","country_code":56},{"name":"Belize","dial_code":"+501","code":"BZ","country_code":84},{"name":"Benin","dial_code":"+229","code":"BJ","country_code":204},{"name":"Bermuda","dial_code":"+1441","code":"BM","country_code":60},{"name":"Bhutan","dial_code":"+975","code":"BT","country_code":64},{"name":"Bolivia, Plurinational State of","dial_code":"+591","code":"BO","country_code":68},{"name":"Bosnia and Herzegovina","dial_code":"+387","code":"BA","country_code":70},{"name":"Botswana","dial_code":"+267","code":"BW","country_code":72},{"name":"Brazil","dial_code":"+55","code":"BR","country_code":76},{"name":"British Indian Ocean Territory","dial_code":"+246","code":"IO","country_code":86},{"name":"Brunei Darussalam","dial_code":"+673","code":"BN","country_code":96},{"name":"Bulgaria","dial_code":"+359","code":"BG","country_code":100},{"name":"Burkina Faso","dial_code":"+226","code":"BF","country_code":854},{"name":"Burundi","dial_code":"+257","code":"BI","country_code":108},{"name":"Cape Verde","dial_code":"+238","code":"CV","country_code":132},{"name":"Cambodia","dial_code":"+855","code":"KH","country_code":116},{"name":"Cameroon","dial_code":"+237","code":"CM","country_code":120},{"name":"Canada","dial_code":"+1","code":"CA","country_code":124},{"name":"Cayman Islands","dial_code":"+ 345","code":"KY","country_code":136},{"name":"Central African Republic","dial_code":"+236","code":"CF","country_code":140},{"name":"Chad","dial_code":"+235","code":"TD","country_code":148},{"name":"Chile","dial_code":"+56","code":"CL","country_code":152},{"name":"China","dial_code":"+86","code":"CN","country_code":156},{"name":"Christmas Island","dial_code":"+61","code":"CX","country_code":162},{"name":"Cocos (Keeling) Islands","dial_code":"+61","code":"CC","country_code":166},{"name":"Colombia","dial_code":"+57","code":"CO","country_code":170},{"name":"Comoros","dial_code":"+269","code":"KM","country_code":174},{"name":"Congo","dial_code":"+242","code":"CG","country_code":178},{"name":"Congo, The Democratic Republic of the Congo","dial_code":"+243","code":"CD","country_code":180},{"name":"Cook Islands","dial_code":"+682","code":"CK","country_code":184},{"name":"Costa Rica","dial_code":"+506","code":"CR","country_code":188},{"name":"Cote d'Ivoire","dial_code":"+225","code":"CI","country_code":384},{"name":"Croatia","dial_code":"+385","code":"HR","country_code":191},{"name":"Cuba","dial_code":"+53","code":"CU","country_code":192},{"name":"Cyprus","dial_code":"+357","code":"CY","country_code":196},{"name":"Czech Republic","dial_code":"+420","code":"CZ","country_code":203},{"name":"Denmark","dial_code":"+45","code":"DK","country_code":208},{"name":"Djibouti","dial_code":"+253","code":"DJ","country_code":262},{"name":"Dominica","dial_code":"+1767","code":"DM","country_code":212},{"name":"Dominican Republic","dial_code":"+1849","code":"DO","country_code":214},{"name":"Ecuador","dial_code":"+593","code":"EC","country_code":218},{"name":"Egypt","dial_code":"+20","code":"EG","country_code":818},{"name":"El Salvador","dial_code":"+503","code":"SV","country_code":222},{"name":"Equatorial Guinea","dial_code":"+240","code":"GQ","country_code":226},{"name":"Eritrea","dial_code":"+291","code":"ER","country_code":232},{"name":"Estonia","dial_code":"+372","code":"EE","country_code":233},{"name":"Swaziland","dial_code":"+268","code":"SZ","country_code":748},{"name":"Ethiopia","dial_code":"+251","code":"ET","country_code":231},{"name":"Falkland Islands (Malvinas)","dial_code":"+500","code":"FK","country_code":238},{"name":"Faroe Islands","dial_code":"+298","code":"FO","country_code":234},{"name":"Fiji","dial_code":"+679","code":"FJ","country_code":242},{"name":"Finland","dial_code":"+358","code":"FI","country_code":246},{"name":"France","dial_code":"+33","code":"FR","country_code":250},{"name":"French Guiana","dial_code":"+594","code":"GF","country_code":254},{"name":"French Polynesia","dial_code":"+689","code":"PF","country_code":258},{"name":"Gabon","dial_code":"+241","code":"GA","country_code":266},{"name":"Gambia","dial_code":"+220","code":"GM","country_code":270},{"name":"Georgia","dial_code":"+995","code":"GE","country_code":268},{"name":"Germany","dial_code":"+49","code":"DE","country_code":276},{"name":"Ghana","dial_code":"+233","code":"GH","country_code":288},{"name":"Gibraltar","dial_code":"+350","code":"GI","country_code":292},{"name":"Greece","dial_code":"+30","code":"GR","country_code":300},{"name":"Greenland","dial_code":"+299","code":"GL","country_code":304},{"name":"Grenada","dial_code":"+1473","code":"GD","country_code":308},{"name":"Guadeloupe","dial_code":"+590","code":"GP","country_code":312},{"name":"Guam","dial_code":"+1671","code":"GU","country_code":316},{"name":"Guatemala","dial_code":"+502","code":"GT","country_code":320},{"name":"Guernsey","dial_code":"+44","code":"GG","country_code":831},{"name":"Guinea","dial_code":"+224","code":"GN","country_code":324},{"name":"Guinea-Bissau","dial_code":"+245","code":"GW","country_code":624},{"name":"Guyana","dial_code":"+595","code":"GY","country_code":328},{"name":"Haiti","dial_code":"+509","code":"HT","country_code":332},{"name":"Holy See (Vatican City State)","dial_code":"+379","code":"VA","country_code":336},{"name":"Honduras","dial_code":"+504","code":"HN","country_code":340},{"name":"Hong Kong","dial_code":"+852","code":"HK","country_code":344},{"name":"Hungary","dial_code":"+36","code":"HU","country_code":348},{"name":"Iceland","dial_code":"+354","code":"IS","country_code":352},{"name":"India","dial_code":"+91","code":"IN","country_code":356},{"name":"Indonesia","dial_code":"+62","code":"ID","country_code":360},{"name":"Iran, Islamic Republic of Persian Gulf","dial_code":"+98","code":"IR","country_code":364},{"name":"Iraq","dial_code":"+964","code":"IQ","country_code":368},{"name":"Ireland","dial_code":"+353","code":"IE","country_code":372},{"name":"Isle of Man","dial_code":"+44","code":"IM","country_code":833},{"name":"Israel","dial_code":"+972","code":"IL","country_code":376},{"name":"Italy","dial_code":"+39","code":"IT","country_code":380},{"name":"Jamaica","dial_code":"+1876","code":"JM","country_code":388},{"name":"Japan","dial_code":"+81","code":"JP","country_code":392},{"name":"Jersey","dial_code":"+44","code":"JE","country_code":832},{"name":"Jordan","dial_code":"+962","code":"JO","country_code":400},{"name":"Kazakhstan","dial_code":"+77","code":"KZ","country_code":398},{"name":"Kenya","dial_code":"+254","code":"KE","country_code":404},{"name":"Kiribati","dial_code":"+686","code":"KI","country_code":296},{"name":"Korea, Democratic People's Republic of Korea","dial_code":"+850","code":"KP","country_code":408},{"name":"Korea, Republic of South Korea","dial_code":"+82","code":"KR","country_code":410},{"name":"Kuwait","dial_code":"+965","code":"KW","country_code":414},{"name":"Kyrgyzstan","dial_code":"+996","code":"KG","country_code":417},{"name":"Laos","dial_code":"+856","code":"LA","country_code":418},{"name":"Latvia","dial_code":"+371","code":"LV","country_code":428},{"name":"Lebanon","dial_code":"+961","code":"LB","country_code":422},{"name":"Lesotho","dial_code":"+266","code":"LS","country_code":426},{"name":"Liberia","dial_code":"+231","code":"LR","country_code":430},{"name":"Libyan Arab Jamahiriya","dial_code":"+218","code":"LY","country_code":434},{"name":"Liechtenstein","dial_code":"+423","code":"LI","country_code":438},{"name":"Lithuania","dial_code":"+370","code":"LT","country_code":440},{"name":"Luxembourg","dial_code":"+352","code":"LU","country_code":442},{"name":"Macao","dial_code":"+853","code":"MO","country_code":446},{"name":"Madagascar","dial_code":"+261","code":"MG","country_code":450},{"name":"Malawi","dial_code":"+265","code":"MW","country_code":454},{"name":"Malaysia","dial_code":"+60","code":"MY","country_code":458},{"name":"Maldives","dial_code":"+960","code":"MV","country_code":462},{"name":"Mali","dial_code":"+223","code":"ML","country_code":466},{"name":"Malta","dial_code":"+356","code":"MT","country_code":470},{"name":"Marshall Islands","dial_code":"+692","code":"MH","country_code":584},{"name":"Martinique","dial_code":"+596","code":"MQ","country_code":474},{"name":"Mauritania","dial_code":"+222","code":"MR","country_code":478},{"name":"Mauritius","dial_code":"+230","code":"MU","country_code":480},{"name":"Mayotte","dial_code":"+262","code":"YT","country_code":175},{"name":"Mexico","dial_code":"+52","code":"MX","country_code":484},{"name":"Micronesia, Federated States of Micronesia","dial_code":"+691","code":"FM","country_code":583},{"name":"Moldova","dial_code":"+373","code":"MD","country_code":498},{"name":"Monaco","dial_code":"+377","code":"MC","country_code":492},{"name":"Mongolia","dial_code":"+976","code":"MN","country_code":496},{"name":"Montenegro","dial_code":"+382","code":"ME","country_code":499},{"name":"Montserrat","dial_code":"+1664","code":"MS","country_code":500},{"name":"Morocco","dial_code":"+212","code":"MA","country_code":504},{"name":"Mozambique","dial_code":"+258","code":"MZ","country_code":508},{"name":"Myanmar","dial_code":"+95","code":"MM","country_code":104},{"name":"Namibia","dial_code":"+264","code":"NA","country_code":516},{"name":"Nauru","dial_code":"+674","code":"NR","country_code":520},{"name":"Nepal","dial_code":"+977","code":"NP","country_code":524},{"name":"Netherlands","dial_code":"+31","code":"NL","country_code":528},{"name":"New Caledonia","dial_code":"+687","code":"NC","country_code":540},{"name":"New Zealand","dial_code":"+64","code":"NZ","country_code":554},{"name":"Nicaragua","dial_code":"+505","code":"NI","country_code":558},{"name":"Niger","dial_code":"+227","code":"NE","country_code":562},{"name":"Nigeria","dial_code":"+234","code":"NG","country_code":566},{"name":"Niue","dial_code":"+683","code":"NU","country_code":570},{"name":"Norfolk Island","dial_code":"+672","code":"NF","country_code":574},{"name":"Macedonia","dial_code":"+389","code":"MK","country_code":807},{"name":"Northern Mariana Islands","dial_code":"+1670","code":"MP","country_code":580},{"name":"Norway","dial_code":"+47","code":"NO","country_code":578},{"name":"Oman","dial_code":"+968","code":"OM","country_code":512},{"name":"Pakistan","dial_code":"+92","code":"PK","country_code":586},{"name":"Palau","dial_code":"+680","code":"PW","country_code":585},{"name":"Palestinian Territory, Occupied","dial_code":"+970","code":"PS","country_code":275},{"name":"Panama","dial_code":"+507","code":"PA","country_code":591},{"name":"Papua New Guinea","dial_code":"+675","code":"PG","country_code":598},{"name":"Paraguay","dial_code":"+595","code":"PY","country_code":600},{"name":"Peru","dial_code":"+51","code":"PE","country_code":604},{"name":"Philippines","dial_code":"+63","code":"PH","country_code":608},{"name":"Pitcairn","dial_code":"+872","code":"PN","country_code":612},{"name":"Poland","dial_code":"+48","code":"PL","country_code":616},{"name":"Portugal","dial_code":"+351","code":"PT","country_code":620},{"name":"Puerto Rico","dial_code":"+1939","code":"PR","country_code":630},{"name":"Qatar","dial_code":"+974","code":"QA","country_code":634},{"name":"Reunion","dial_code":"+262","code":"RE","country_code":638},{"name":"Romania","dial_code":"+40","code":"RO","country_code":642},{"name":"Russia","dial_code":"+7","code":"RU","country_code":643},{"name":"Rwanda","dial_code":"+250","code":"RW","country_code":646},{"name":"Saint Barthelemy","dial_code":"+590","code":"BL","country_code":652},{"name":"Saint Helena, Ascension and Tristan Da Cunha","dial_code":"+290","code":"SH","country_code":654},{"name":"Saint Kitts and Nevis","dial_code":"+1869","code":"KN","country_code":659},{"name":"Saint Lucia","dial_code":"+1758","code":"LC","country_code":662},{"name":"Saint Martin","dial_code":"+590","code":"MF","country_code":663},{"name":"Saint Pierre and Miquelon","dial_code":"+508","code":"PM","country_code":666},{"name":"Saint Vincent and the Grenadines","dial_code":"+1784","code":"VC","country_code":670},{"name":"Samoa","dial_code":"+685","code":"WS","country_code":882},{"name":"San Marino","dial_code":"+378","code":"SM","country_code":674},{"name":"Sao Tome and Principe","dial_code":"+239","code":"ST","country_code":678},{"name":"Saudi Arabia","dial_code":"+966","code":"SA","country_code":682},{"name":"Senegal","dial_code":"+221","code":"SN","country_code":686},{"name":"Serbia","dial_code":"+381","code":"RS","country_code":688},{"name":"Seychelles","dial_code":"+248","code":"SC","country_code":690},{"name":"Sierra Leone","dial_code":"+232","code":"SL","country_code":694},{"name":"Singapore","dial_code":"+65","code":"SG","country_code":702},{"name":"Slovakia","dial_code":"+421","code":"SK","country_code":703},{"name":"Slovenia","dial_code":"+386","code":"SI","country_code":705},{"name":"Solomon Islands","dial_code":"+677","code":"SB","country_code":90},{"name":"Somalia","dial_code":"+252","code":"SO","country_code":706},{"name":"South Africa","dial_code":"+27","code":"ZA","country_code":710},{"name":"South Georgia and the South Sandwich Islands","dial_code":"+500","code":"GS","country_code":239},{"name":"South Sudan","dial_code":"+211","code":"SS","country_code":728},{"name":"Spain","dial_code":"+34","code":"ES","country_code":724},{"name":"Sri Lanka","dial_code":"+94","code":"LK","country_code":144},{"name":"Sudan","dial_code":"+249","code":"SD","country_code":729},{"name":"Suriname","dial_code":"+597","code":"SR","country_code":740},{"name":"Svalbard and Jan Mayen","dial_code":"+47","code":"SJ","country_code":744},{"name":"Sweden","dial_code":"+46","code":"SE","country_code":752},{"name":"Switzerland","dial_code":"+41","code":"CH","country_code":756},{"name":"Syrian Arab Republic","dial_code":"+963","code":"SY","country_code":760},{"name":"Taiwan","dial_code":"+886","code":"TW","country_code":158},{"name":"Tajikistan","dial_code":"+992","code":"TJ","country_code":762},{"name":"Tanzania, United Republic of Tanzania","dial_code":"+255","code":"TZ","country_code":834},{"name":"Thailand","dial_code":"+66","code":"TH","country_code":764},{"name":"Timor-Leste","dial_code":"+670","code":"TL","country_code":626},{"name":"Togo","dial_code":"+228","code":"TG","country_code":768},{"name":"Tokelau","dial_code":"+690","code":"TK","country_code":772},{"name":"Tonga","dial_code":"+676","code":"TO","country_code":776},{"name":"Trinidad and Tobago","dial_code":"+1868","code":"TT","country_code":780},{"name":"Tunisia","dial_code":"+216","code":"TN","country_code":788},{"name":"Turkey","dial_code":"+90","code":"TR","country_code":792},{"name":"Turkmenistan","dial_code":"+993","code":"TM","country_code":795},{"name":"Turks and Caicos Islands","dial_code":"+1649","code":"TC","country_code":796},{"name":"Tuvalu","dial_code":"+688","code":"TV","country_code":798},{"name":"Uganda","dial_code":"+256","code":"UG","country_code":800},{"name":"Ukraine","dial_code":"+380","code":"UA","country_code":804},{"name":"United Arab Emirates","dial_code":"+971","code":"AE","country_code":784},{"name":"United Kingdom","dial_code":"+44","code":"GB","country_code":826},{"name":"United States","dial_code":"+1","code":"US","country_code":840},{"name":"Uruguay","dial_code":"+598","code":"UY","country_code":858},{"name":"Uzbekistan","dial_code":"+998","code":"UZ","country_code":860},{"name":"Vanuatu","dial_code":"+678","code":"VU","country_code":548},{"name":"Venezuela, Bolivarian Republic of Venezuela","dial_code":"+58","code":"VE","country_code":862},{"name":"Vietnam","dial_code":"+84","code":"VN","country_code":704},{"name":"Virgin Islands, British","dial_code":"+1284","code":"VG","country_code":92},{"name":"Virgin Islands, U.S.","dial_code":"+1340","code":"VI","country_code":850},{"name":"Wallis and Futuna","dial_code":"+681","code":"WF","country_code":876},{"name":"Yemen","dial_code":"+967","code":"YE","country_code":887},{"name":"Zambia","dial_code":"+260","code":"ZM","country_code":894},{"name":"Zimbabwe","dial_code":"+263","code":"ZW","country_code":716}]`)
  } catch {
    return [{ name: 'Malaysia', dial_code: '+60', code: 'MY' }]
  }
}

Vue.prototype.$PaymentDetail = function (payment) {
  // GROUP_CONCAT(p.id,'-|-',p.payment_type,'-|-',p.amount,'-|-',p.status,'-|-',COALESCE(p.payment_link, '') SEPARATOR ']-[') payments
  const pay = (payment + '').split(']-[')
  let amount = 0
  let paymentType = ''
  let paymentLink = ''
  for (let a = 0; a < pay.length; a++) {
    const d = (pay[a].split('-|-')) || []
    if (d.length > 2) {
      if (parseInt(d[3])) { // status
        amount += (parseInt(d[2]) || 0) // amount
      }
      paymentType = d[1] || paymentType || ''
      paymentLink = (d[4] !== '-' ? d[4] : '') || paymentLink || ''
    }
  }
  return {
    amount,
    paymentType,
    paymentLink
  }
}

Vue.prototype.$StatusPickup = function (pickup) {
  // 0: Waiting Payment, 1: Confirmed (menunggu driver/courier, menunggu pelunasan), 2: DIkonfirmasi kurir, sedang dalam perjalanan. 3: Berhasil di pickup. 4: Diterima cabang
  if (!pickup) {
    return {
      text: 'Undefined',
      color: 'grey lighten--1'
    }
  }
  if (parseInt(pickup.status) === 4) {
    return {
      text: 'Diterima Cabang',
      color: 'green'
    }
  } else if (parseInt(pickup.status) === 3) {
    return {
      text: (parseInt(pickup.price_paid) || 0) < (parseInt(pickup.price_total) || 0) ? 'Berhasil dipickup ' + (pickup.courier_detail || '-') + (pickup.payments ? '<div class="orange--text">Menunggu pembayaran</div>' : '<div class="yellow--text">Menunggu Update Kiriman</div>') : 'Berhasil dipickup ' + (pickup.courier_detail || '-') + '<div>Paket sedang diantarkan ke cabang</div>',
      color: 'green'
    }
  } else if (parseInt(pickup.status) === 2) {
    // Sudah di konfirmasi oleh kurir, ada opsi ganti kurir pickup
    return {
      text: parseInt(pickup.courier) ? ('Kurir ' + pickup.courier_detail) + '<div>Dalam perjalanan menjemput paket</div>' : '',
      color: 'blue'
    }
  } else if (parseInt(pickup.status) === 1) {
    // jika sudah lunas, maka bisa assign kurir, dam ada opsi ganti cabang (dalam status Sedang menunggu kurir)
    return {
      text: parseInt(pickup.courier) ? ('Menunggu Konfirmasi Kurir :<div>' + pickup.courier_detail) + '</div>' : 'Undefined',
      color: 'orange'
    }
  } else {
    return {
      text: 'Menunggu Konfirmasi',
      color: 'red darken-2'
    }
  }
}

Vue.prototype.$ConvertExcelDate = function (dt) {
  if (dt) {
    dt = dt.trim()
    const d = dt.split('/')
    if (d.length === 3) {
      return d[2] + '-' + d[1] + '-' + d[0]
    } else {
      const e = dt.split('-')
      if (e.length === 3) {
        return e[2] + '/' + e[1] + '/' + e[0]
      }
    }
  }
  return ''
}

Vue.prototype.$ValidateExcelDate = function (dt) {
  const d = dt.split('/')
  if (d.length === 3) {
    const dd = parseInt(d[0]) || 0
    const mm = parseInt(d[1]) || 0
    const yyyy = parseInt(d[2]) || 0
    return dd && parseInt(d[1]) && parseInt(d[2]) && (dd < 32) && (mm < 13) && (yyyy < 2050)
  }
  return false
}

Vue.prototype.$sortArray = function (arr, key, desc) {
  return sortArray(arr, key, desc)
}

Vue.filter('price', function (value) {
  if (!value) {
    return 'Rp 0'
  }
  value = parseInt(value).toLocaleString()
  return 'Rp ' + value
})

function ValidatedPriceCounter (type, v1, v2) {
  if (type === 'quantity') {
    if ((parseInt(v1) || 0) >= (parseInt(v2) || 0)) {
      return true
    }
  } else if (type === 'customer') {
    if (isNaN(parseInt(v2))) {
      return true
    } else if (parseInt(v2) === parseInt(v1)) {
      return true
    }
  } else if (type === 'platform') {
    if (isNaN(parseInt(v2))) {
      return true
    } else if (parseInt(v2) === parseInt(v1)) {
      return true
    }
  }
  return false
}

Vue.prototype.$priceCounter = function (pbj, price, quantity, customerType, platform) {
  price = parseInt(price)
  let priceAdded = 0
  let data = null
  const priceBerjenjang = pbj ? sortArray(pbj, 'minimum_quantity', true) : []
  for (let c = 0; c < priceBerjenjang.length; c++) {
    const pb = priceBerjenjang[c]
    if (ValidatedPriceCounter('quantity', quantity, pb.minimum_quantity) && ValidatedPriceCounter('customer', customerType, pb.customer) && ValidatedPriceCounter('platform', platform, pb.platform)) {
      if (!data) {
        data = Object.assign({}, pb)
        priceAdded = parseInt(pb.discount) || 0
      }
    }
  }
  return {
    data: data,
    price: (price - priceAdded) || price
  }
}

Vue.prototype.$CART_PARSE = function (cart) {
  let amountSubtotal = 0
  let amountTax = 0
  let weight = 0
  for (let c = 0; c < cart.length; c++) {
    amountSubtotal += (parseFloat(cart[c].priceActive) * parseInt(cart[c].quantity))
    weight += (parseFloat(cart[c].weight) * parseInt(cart[c].quantity))
  }
  amountTax += (amountSubtotal * (10 / 100))
  return {
    amountSubtotal,
    amountTax,
    weight
  }
}

Vue.prototype.$SHIPPING_COST = function (weight, pricePerKg) {
  let kgs = ((weight || 1) / 1000)
  if ((kgs % 1) > 0.2) {
    kgs = Math.ceil(kgs)
  } else {
    kgs = Math.floor(kgs)
  }
  if (kgs < 1) {
    kgs = 1
  }
  return parseFloat(pricePerKg || 0) * kgs
}

Vue.prototype.$IsPast = function (dt) {
  return (new Date().getTime()) > (new Date(dt).getTime())
}

Vue.prototype.$ParseBookingPayment = function (paymentsArray) {
  let link = null
  let paid = 0
  const data = []
  if (typeof paymentsArray === 'object' && paymentsArray.length) {
    for (let p = 0; p < paymentsArray.length; p++) {
      const paymentSplit = paymentsArray[p].split('|')
      if (paymentSplit.length === 8) {
        const status = parseInt(paymentSplit[6]) || 0
        if (status === 1) {
          paid += parseFloat(paymentSplit[1])
          link = paymentSplit[7] || null
        } else if (!status) {
          paid += parseFloat(paymentSplit[1])
          link = paymentSplit[7] || null
        }
        data.push({
          id: parseInt(paymentSplit[0]),
          amount_paid: parseFloat(paymentSplit[1]),
          amount: parseFloat(paymentSplit[2]),
          payment_inout: parseInt(paymentSplit[3]) || 0,
          payment_type: parseInt(paymentSplit[4]) || 0,
          created: paymentSplit[5],
          status: status
        })
      }
    }
    return {
      paid,
      link,
      data
    }
  }
  return {
    paid,
    link,
    data
  }
}

Vue.prototype.$countPriceActive = function (date, priceDay, priceWeekend, priceWeekday, priceDefault) {
  const isWeekend = (new Date(date).getDay() % 6) === 0
  priceDay = parseFloat(priceDay) || 0
  priceWeekend = parseFloat(priceWeekend) || 0
  priceWeekday = parseFloat(priceWeekday) || 0
  priceDefault = parseFloat(priceDefault) || 0
  return {
    type: priceDay ? 'price-by-date' : ((isWeekend && priceWeekend) || (!isWeekend && priceWeekday) ? 'price-week' : 'price-default'),
    price: priceDay || (isWeekend ? (priceWeekend || priceDefault) : (priceWeekday || priceDefault))
  }
}

Vue.prototype.$BookingStatus = function (status) {
  const st = {
    name: 'Undefined',
    color: 'red',
    icon: 'mdi-minus'
  }
  switch (parseInt(status)) {
    case 0:
      st.name = 'Unpaid'
      st.color = 'red'
      st.icon = 'mdi-av-timer'
      break
    case 1:
      st.name = 'Paid'
      st.color = 'blue'
      st.icon = 'mdi-package-variant'
      break
    case 2:
      st.name = 'Checked-In'
      st.color = 'purple'
      st.icon = 'mdi-truck-fast-outline'
      break
    case 3:
      st.name = 'Completed'
      st.color = 'indigo'
      st.icon = 'mdi-store-check'
      break
    case 98:
      st.name = 'Canceled - Refund'
      st.color = 'red'
      st.icon = 'mdi-table-cancel'
      break
    case 99:
      st.name = 'Canceled'
      st.color = 'brown'
      st.icon = 'mdi-table-cancel'
      break
    case 100:
      st.name = 'Deleted'
      st.color = 'grey'
      st.icon = 'mdi-close-thick'
      break
    default:
      st.name = 'Undefined'
      st.color = 'grey'
      st.icon = 'mdi-information-off-outline'
      break
  }
  // unpaid: [], // STATUS : 0 unpaid
  // confirmed: [], // STATUS : 1 paid, 2 confirmed & room settled, 3 checked_in/ongoing & room settled, 4 checked_out/complete
  // canceled: [] // STATUS : 98 canceled refund, 99 canceled no reason, 100 deleted
  return st
}

Vue.prototype.$total = function (cart) {
  let total = 0
  if (cart) {
    if (cart.length) {
      for (let c = 0; c < cart.length; c++) {
        const priceItem = parseInt(cart[c].priceActive)
        total += (priceItem * (parseInt(cart[c].quantity)) || 1)
      }
    }
  }
  return total
}

Vue.prototype.$price = function (price, sign) {
  if (!price) {
    return (sign || 'Rp') + (price)
  }
  price = sign === 'USD' ? parseFloat(price).toFixed(2) : parseInt(price).toLocaleString()
  return (sign || 'Rp') + price
}

Vue.prototype.$ConvWeight = function (weight, decCount, short) {
  if (parseInt(weight)) {
    weight = parseInt(weight)
    if (weight < 1000) {
      return weight + (short ? 'g' : ' grams')
    } else if ((weight / 1000) < 1000) {
      return (weight / 1000).toFixed(decCount || 0) + (short ? 'Kg' : ' Kilogram')
    } else {
      return ((weight / 1000) / 1000).toFixed(decCount || 0) + (short ? 'Ton' : ' Ton')
    }
  } else {
    return (0).toFixed(decCount || 0) + ((short ? 'Kg' : ' Kilogram'))
  }
}

Vue.prototype.$NumOnly = function (e) {
  const key = e.keyCode ? e.keyCode : e.which
  if (isNaN(String.fromCharCode(key)) && key !== 8 && key !== 46 && key !== 37 && key !== 39) {
    e.preventDefault()
    return false
  }
}

Vue.prototype.$validateName = function (name) {
  return /^[A-Za-z\s]+$/.test(name)
}

Vue.prototype.$validateEmail = function (email) {
  // eslint-disable-next-line
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return email ? re.test(email) : false
}

Vue.prototype.$validatePhone = function (phone) {
  if (phone) {
    phone = phone + ''
    if (phone.length > 9 && phone.length < 14) {
      if (phone.substring(0, 2) === '08' || phone.substring(0, 1) === '8' || phone.substring(0, 2) === '08' || phone.substring(0, 3) === '628' || phone.substring(0, 4) === '+628') {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
}

Vue.prototype.$reformatPhone = function (phone) {
  if (phone) {
    if (phone.substring(0, 1) === '8') {
      return '62' + phone
    } else if (phone.substring(0, 2) === '08') {
      return '62' + phone.substring(1, phone.length)
    } else if (phone.substring(0, 2) === '62') {
      return phone
    } else if (phone.substring(0, 3) === '+62') {
      return phone.substring(1, phone.length)
    } else {
      return null
    }
  } else {
    return null
  }
}

Vue.prototype.$moneyInt = function (amount) {
  if (amount && typeof amount === 'string') {
    return parseInt(amount) ? parseInt(amount.split('.')[0].split(',').join('')) : 0
  } else {
    return 0
  }
}

Vue.prototype.$money = function (amount, decimalCount = 2, decimal = '.', thousands = ',') {
  if (amount && typeof amount === 'string') {
    amount = parseInt(amount) ? parseInt(amount.split('.')[0].split(',').join('')) : 0
  } else {
    amount = 0
  }
  try {
    decimalCount = Math.abs(decimalCount)
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount
    const negativeSign = amount < 0 ? '-' : ''

    const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
    const j = (i.length > 3) ? i.length % 3 : 0

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
  } catch (e) {
    console.log(e)
    return 0
  }
}

Vue.prototype.$timeToDecimal = function (t, p) {
  const arr = t.split(':')
  const dec = parseInt((arr[1] / 6) * 10, 10)
  return parseFloat(parseInt(arr[0], 10) + '.' + (dec < 10 ? '0' : '') + dec).toFixed(parseInt(p) ? parseInt(p) : 1)
}

Vue.prototype.$decimalToTime = function (minutes) {
  const sign = minutes < 0 ? '-' : ''
  const min = Math.floor(Math.abs(minutes))
  const sec = Math.floor((Math.abs(minutes) * 60) % 60)
  return sign + (min < 10 ? '0' : '') + min + ':' + (sec < 10 ? '0' : '') + sec
}

Vue.prototype.$getTimeLocal = function (utcDate) {
  const localDate = new Date(utcDate)
  const hour = localDate.getHours()
  const minutes = localDate.getMinutes()
  return (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes)
}

Vue.prototype.$getThisWeek = function (dt) {
  const curr = dt ? new Date(dt) : new Date()
  const first = curr.getDate() - curr.getDay()
  const last = first + 6

  const firstday = new Date(curr.setDate(first)).toUTCString()
  const lastday = new Date(curr.setDate(last)).toUTCString()
  return {
    from: firstday,
    to: lastday
  }
}

Vue.prototype.$MonthName = function (dt, isFullname) {
  const ndate = new Date(dt)
  const monthNames = isFullname ? ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'] : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return monthNames[ndate.getMonth()]
}

Vue.prototype.$getThisMonth = function (dtcustom) {
  const formattedDate = function (date) {
    const m = ('0' + (date.getMonth() + 1)).slice(-2)
    const d = ('0' + date.getDate()).slice(-2)
    const y = date.getFullYear()
    return y + '-' + m + '-' + d
  }
  const currDate = dtcustom ? new Date(dtcustom) : new Date()
  const firstDay = new Date(currDate.getFullYear(), currDate.getMonth(), 1)
  const lastDay = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 0)
  const monthStartDate = formattedDate(firstDay)
  const monthEndDate = formattedDate(lastDay)

  const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

  return {
    start: monthStartDate,
    end: monthEndDate,
    lastDateDay: lastDay.getDate(),
    lastDateDayName: dayNames[lastDay.getDay()],
    lastDateMonth: lastDay.getMonth() + 1,
    lastDateYear: lastDay.getFullYear()
  }
}

Vue.prototype.$statusPlan = function (statusPlan) {
  // smm2.id,'-|-',
  // COALESCE(smm2.status, 0),'-|-',
  // COALESCE(smm2.status_plan, 0),'-|-',
  // COALESCE(smm2.status_plan_img, ''),'-|-',
  // COALESCE(smm2.notes, ''),'-|-',
  // COALESCE(smm2.recipient_name, ''),'-|-',
  // COALESCE(smm2.recipient_relation, ''),'-|-',
  // COALESCE(smm2.recipient_imgs, ''),'-|-',
  // COALESCE(smm2.recipient_notes, ''),'-|-',
  // COALESCE(smm2.recipient_time, ''),'-|-',
  // COALESCE(smm2.recipient_downloaded, 0)
  if (statusPlan) {
    const statusPlanPlit = statusPlan.split('-|-')
    if (parseInt(statusPlanPlit[0])) {
      let statusPlanText = 'DITERIMA'
      if (parseInt(statusPlanPlit[2]) === 1) {
        statusPlanText = 'TERLAMBAT'
      } else if (parseInt(statusPlanPlit[2]) === 2) {
        statusPlanText = 'RUSAK'
      } else if (parseInt(statusPlanPlit[2]) === 3) {
        statusPlanText = 'INVESTIGASI'
      } else if (!parseInt(statusPlanPlit[1])) {
        statusPlanText = '-'
      }
      return {
        id: parseInt(statusPlanPlit[0]) || 0,
        status: parseInt(statusPlanPlit[1]) || 0,
        status_plan: parseInt(statusPlanPlit[2]) || 0,
        status_plan_text: statusPlanText,
        status_plan_img: statusPlanPlit[3] || null,
        notes: statusPlanPlit[4] || '',
        recipient_name: statusPlanPlit[5] || '',
        recipient_relation: statusPlanPlit[6] || '',
        recipient_imgs: statusPlanPlit[7] || '',
        recipient_notes: statusPlanPlit[8] || '',
        recipient_time: statusPlanPlit[9] || '',
        recipient_downloaded: parseInt(statusPlanPlit[10]) || 0
      }
    }
  }
  return {}
}

Vue.prototype.$manifestPlan = function (statusPlan) {
  if (statusPlan) {
    const statusPlanPlit = statusPlan.split('-|-')
    if (parseInt(statusPlanPlit[0])) {
      let statusPlanText = 'DITERIMA'
      if (parseInt(statusPlanPlit[2]) === 1) {
        statusPlanText = 'TERLAMBAT'
      } else if (parseInt(statusPlanPlit[2]) === 2) {
        statusPlanText = 'RUSAK'
      } else if (parseInt(statusPlanPlit[2]) === 3) {
        statusPlanText = 'INVESTIGASI'
      } else if (!parseInt(statusPlanPlit[1])) {
        statusPlanText = '-'
      }
      return {
        id: parseInt(statusPlanPlit[0]) || 0,
        status: parseInt(statusPlanPlit[1]) || 0,
        status_plan: parseInt(statusPlanPlit[2]) || 0,
        status_plan_text: statusPlanText,
        status_plan_img: statusPlanPlit[3] || null,
        notes: statusPlanPlit[4] || ''
      }
    }
  }
  return {}
}

Vue.prototype.$ParseManifest = function (manifest) {
  if (manifest) {
    const manifestData = manifest.split('-|-')
    const id = parseInt(manifestData[0]) || 0
    const type = manifestData[1] || ''
    const departure = manifestData[2] || null
    const arrival = manifestData[3] || null
    const storeOrigin = manifestData[4] || null
    const storeDestination = manifestData[5] || null
    if (arrival) {
      return {
        id,
        status: 'MANIFEST IN',
        type: type,
        statusPlace: storeDestination || '-',
        storeOrigin,
        storeDestination
      }
    } else if (departure) {
      return {
        id,
        status: 'MANIFEST OUT',
        type: type,
        statusPlace: storeOrigin || '-',
        storeOrigin,
        storeDestination
      }
    } else {
      return {
        id,
        status: 'MANIFESTED',
        type: type,
        statusPlace: storeOrigin || '-',
        storeOrigin,
        storeDestination
      }
    }
  }
  return null
}

Vue.prototype.$localDT = function (utcDate, type) {
  const localDate = utcDate ? new Date(utcDate) : new Date()
  const dayNames = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des']
  // const year = localDate.getFullYear().toString().substr(-2)
  const year = localDate.getFullYear().toString()
  const month = monthNames[localDate.getMonth()]
  const day = localDate.getDate()
  const dayName = dayNames[localDate.getDay()]

  /* eslint-disable-next-line */
  const seconds = localDate.getSeconds()
  const minutes = localDate.getMinutes()
  const hour = localDate.getHours()

  if (type === 'daydate') {
    return dayName + ', ' + (day < 10 ? '0' + day : day) + ' ' + month + ' ' + year
  } else if (type === 'daydatetime') {
    return dayName + ', ' + (day < 10 ? '0' + day : day) + ' ' + month + ' ' + year + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes)
  } else if (type === 'number') {
    return (day < 10 ? '0' + day : day) + '' + ((localDate.getMonth() + 1) < 10 ? '0' + (localDate.getMonth() + 1) : (localDate.getMonth() + 1)) + '' + year.substr(2, 2)
  } else if (type === 'date') {
    return dayName + ' ' + month + ', ' + year
  } else if (type === 'display') {
    return month + ' ' + (day < 10 ? '0' + day : day) + ', ' + year
  } else if (type === 'displaylocal') {
    return (day < 10 ? '0' + day : day) + ' ' + month + ', ' + year
  } else if (type === 'datelocal') {
    return (day < 10 ? '0' + day : day) + '/' + ((localDate.getMonth() + 1) < 10 ? '0' + (localDate.getMonth() + 1) : (localDate.getMonth() + 1)) + '/' + year
  } else if (type === 'monthyear') {
    return month + ', ' + year
  } else if (type === 'datedefault') {
    return year + '-' + ((localDate.getMonth() + 1) < 10 ? '0' + (localDate.getMonth() + 1) : (localDate.getMonth() + 1)) + '-' + (day < 10 ? '0' + day : day)
  } else if (type === 'datetimedefault') {
    return year + '-' + ((localDate.getMonth() + 1) < 10 ? '0' + (localDate.getMonth() + 1) : (localDate.getMonth() + 1)) + '-' + (day < 10 ? '0' + day : day) + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes)
  } else if (type === 'time') {
    return (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes)
  } else if (type === 'datetime') {
    return dayName + ', ' + day + ' ' + month + ' ' + year + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':00'
  } else {
    return year + '-' + ((localDate.getMonth() + 1) < 10 ? '0' + (localDate.getMonth() + 1) : (localDate.getMonth() + 1)) + '-' + (day < 10 ? '0' + day : day)
  }
}

Vue.prototype.$diffTimes = function (dt2, dt1) {
  let diff = (dt2.getTime() - dt1.getTime()) / 1000
  diff /= (60 * 60)
  return parseFloat(diff).toFixed(2)
}

Vue.prototype.$getThisYear = function () {
  const curr = new Date()
  const year = curr.getFullYear()

  const firstyear = new Date(year + '-01-01').toUTCString()
  const lastyear = new Date(year + '-12-31').toUTCString()
  return {
    from: firstyear,
    to: lastyear
  }
}

Vue.prototype.$getImage = function (featured, index) {
  try {
    const newGalleries = typeof featured === 'string' ? (featured === '{}' ? [] : JSON.parse(featured)) : featured
    if (newGalleries.length) {
      const img = newGalleries[index || 0]
      return (typeof img === 'string') ? img : (img.src || '/no-image.png')
    } else {
      return '/no-image.png'
    }
  } catch {
    return '/no-image.png'
  }
}

Vue.prototype.$getImageAll = function (galleriesString, isObj) {
  try {
    const newGalleries = JSON.parse(galleriesString)
    if (newGalleries.length) {
      return newGalleries
    } else {
      return isObj ? [] : ['/no-image.png']
    }
  } catch {
    return isObj ? [] : ['/no-image.png']
  }
}

Vue.prototype.$isValidateDateTime = function (datetime) {
  datetime = (datetime + '').trim()
  if (datetime) {
    if (datetime.length === 19) {
      if (datetime.split('-').length === 3) {
        if (datetime.split(':').length === 3) {
          if (datetime.split(' ').length === 2) {
            return true
          }
        }
      }
    }
  }
  return false
}

Vue.prototype.$VolumeMetric = function (item, divAmount) {
  const length = (parseFloat(item.volume_length) || 0)
  const width = (parseFloat(item.volume_width) || 0)
  const height = (parseFloat(item.volume_height) || 0)
  return parseFloat(parseFloat((length * width * height) / (parseInt(divAmount) || 4000)).toFixed(2))
}

Vue.prototype.$countShippingWeight = function (item, isMaster, divAmount) {
  if (isMaster) {
    const weight = parseFloat(item.master_weight_kg_actual) || 0
    const length = parseFloat(item.master_weight_volume_length) || 0
    const width = parseFloat(item.master_weight_volume_width) || 0
    const height = parseFloat(item.master_weight_volume_height) || 0

    let weightVolume = 0
    if (item.master_count_type === 'UNIT') {
      return 1
    } else if (item.master_count_type === 'KG') {
      return weight
    } else if (item.master_count_type === 'KUBIK') {
      weightVolume = parseFloat(parseFloat((length * width * height) / (parseInt(divAmount) || 4000)).toFixed(2))
    }

    if (length && width && height) {
      weightVolume = parseFloat(parseFloat((length * width * height) / (parseInt(divAmount) || 4000)).toFixed(2))
    }
    if (weight && weightVolume) {
      return (weight > weightVolume) ? weight : weightVolume
    } else {
      return weight || weightVolume
    }
  } else {
    const weight = parseFloat(item.weight_kg_actual) || 0
    const length = parseFloat(item.weight_volume_length) || 0
    const width = parseFloat(item.weight_volume_width) || 0
    const height = parseFloat(item.weight_volume_height) || 0

    let weightVolume = 0
    if (item.type === 'UNIT') {
      return 1
    } else if (item.type === 'KG') {
      return weight
    } else if (item.type === 'KUBIK') {
      weightVolume = parseFloat(parseFloat((length * width * height) / (parseInt(divAmount) || 4000)).toFixed(2))
    }

    if (length && width && height) {
      weightVolume = parseFloat(parseFloat((length * width * height) / (parseInt(divAmount) || 4000)).toFixed(2))
    }
    if (weight && weightVolume) {
      return (weight > weightVolume) ? weight : weightVolume
    } else {
      return weight || weightVolume
    }
  }
}

Vue.prototype.$Last7Days = function () {
  return '0123456'.split('').map(function (n) {
    const d = new Date()
    d.setDate(d.getDate() - n)

    return (function (day, month, year) {
      return [year, ((month < 10) ? ('0' + month) : month), ((day < 10) ? '0' + day : day)].join('-')
    })(d.getDate(), d.getMonth(), d.getFullYear())
  }).join(',')
}

Vue.prototype.$ext = function (fname) {
  const lastDot = (fname || '').lastIndexOf('.')
  return fname.substring(lastDot + 1)
}

Vue.prototype.$filetoBase64 = function (event, callback) {
  /* eslint-disable */
  function getType(ext) {
    if (ext === 'mov' || ext === 'mp4' || ext === 'avi' || ext === 'flv') {
      return 'video'
    } else if (ext === 'doc' || ext === 'docx' || ext === 'ppt' || ext === 'pptx' || ext === 'xls' || ext === 'xlsx' || ext === 'csv' || ext === 'txt' || ext === 'pdf' || ext === 'psd') {
      return 'doc'
    } else if (ext === 'jpg' || ext === 'jpeg' || ext === 'gif' || ext === 'png' || ext === 'svg') {
      return 'photo'
    } else if (ext === 'mp3' || ext === 'wav') {
      return 'audio'
    } else if (ext === 'csv') {
      return 'csv'
    } else {
      return 'unknown'
    }
  }
  let r = {
    status: false,
    ext: '',
    type: '',
    name: '',
    data: null
  }
  let f = event.target.files || event.dataTransfer.files

  if (f.length > 1) {
    const d = []
    for (let g = 0; g < f.length; g++) {
      const reader = new FileReader()
      let rr = {
        status: false,
        ext: '',
        type: '',
        name: '',
        data: null
      }
      const fname = f[g].name
      const lastDot = fname.lastIndexOf('.')
      rr.ext = fname.substring(lastDot + 1)
      rr.type = getType(rr.ext)
      rr.name = fname || ''
  
      const fSize = (1024 * 1024 * 20)
  
      if (f[g].size <= fSize) {
        reader.readAsDataURL(f[g])
        reader.onload = function (ev) {
          rr.status = true
          rr.data = ev.target.result
          d.push(rr)
        }
        reader.onerror = function (error) {
          rr.status = false
          rr.data = error
          d.push(rr)
        }
      } else {
        rr.status = false
        rr.data = 'file_size'
        d.push(rr)
      }
    }
    callback(d)
  } else if (f[0]) {
    const reader = new FileReader()
    const fname = event.target.files[0].name
    const lastDot = fname.lastIndexOf('.')
    r.ext = fname.substring(lastDot + 1)
    r.type = getType(r.ext)
    r.name = fname || ''

    const fSize = (1024 * 1024 * 20)

    if (f[0].size <= fSize) {
      reader.readAsDataURL(f[0])
      reader.onload = function (ev) {
        r.status = true
        r.data = ev.target.result
        callback(r)
      }
      reader.onerror = function (error) {
        r.status = false
        r.data = error
        callback(r)
      }
    } else {
      r.status = false
      r.data = 'file_size'
      callback(r)
    }
  } else {
    r.status = false
    r.data = 'canceled'
    callback(r)
  }
}

Vue.prototype.$displayWeight = function (weight, decCount, short) {
  if (parseInt(weight)) {
    weight = parseInt(weight)
    if (weight < 1000) {
      return weight + (short ? 'g' : ' gram')
    } else if ((weight / 1000) < 100) {
      return (weight / 1000).toFixed(decCount || 0) + (short ? 'Kg' : ' Kilogram')
    } else if ((weight / 1000) < 1000) {
      return ((weight / 1000) / 100).toFixed(decCount || 0) + (short ? 'Q' : ' Quintal')
    } else {
      return ((weight / 1000) / 1000).toFixed(decCount || 0) + (short ? 'Ton' : ' Ton')
    }
  } else {
    return 0
  }
}

Vue.prototype.$convToGrams = function (weight, unit) {
  if (unit === 'ton') {
    return parseInt(weight) * 1000000
  } else if (unit === 'quintal') {
    return parseInt(weight) * 100000
  } else if (unit === 'kg') {
    return parseInt(weight) * 1000
  } else {
    return parseInt(weight) || 0 // grams
  }
}

Vue.prototype.$role = function (roles, role) {
  if (!roles) {
    return true
  }
  if (role === 'root' || role === 'admin') {
    return true
  } else {
    return roles ? roles.find(item => item === role) : false
  }
}

Vue.prototype.$TodayDate = function () {
  const today = new Date()
  const dd = String(today.getDate()).padStart(2, '0')
  const mm = String(today.getMonth() + 1).padStart(2, '0')
  const yyyy = today.getFullYear()
  const todaydate = yyyy + '-' + mm + '-' + dd
  return todaydate
}

Vue.prototype.$DateReformat = function (dt) {
  const ndate = new Date(dt)
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]
  const year = ndate.getFullYear().toString().substr(-2)
  const month = monthNames[ndate.getMonth()]
  const day = ndate.getDate()
  return day + ' ' + month + ' ' + year
}

Vue.prototype.$DateRangeDays = function (fromd, tod) {
  const from = fromd ? (new Date(fromd)) : (new Date())
  const to = tod ? (new Date(tod)) : (new Date())
  return parseInt(((to - from) / 86400000))
}

Vue.prototype.$DateDiffDays = function (dt, days) {
  const date = new Date(dt)
  date.setDate(date.getDate() - days)
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const yyyy = date.getFullYear()
  const ddt = yyyy + '-' + mm + '-' + dd
  return ddt
}

Vue.prototype.$DateAddDays = function (dt, days) {
  const date = new Date(dt)
  date.setDate(date.getDate() + days)
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const yyyy = date.getFullYear()
  const ddt = yyyy + '-' + mm + '-' + dd
  return ddt
}

Vue.prototype.$NumberOnly = function (e) {
  const key = e.keyCode ? e.keyCode : e.which
  if (isNaN(String.fromCharCode(key)) && key !== 8 && key !== 46 && key !== 37 && key !== 39 && key !== 190) {
    e.preventDefault()
    return false
  }
}

Vue.prototype.$AlphaNumeric = function (str) {
  if (str) {
    str = str.replace(/[\W_]+/g, "").toUpperCase()
  }
  return str || ''
}

Vue.prototype.$JsonToStr = function (json) {
  if (json) {
    try {
      json = JSON.stringify(json)
    } catch {
      json = ''
    }
    return json
  }
  return ''
}

Vue.prototype.$StrToJson = function (str) {
  if (str) {
    try {
      str = JSON.parse(str)
    } catch {
      str = {}
    }
    return str
  }
  return {}
}

Vue.prototype.$ArrayToStr = function (json) {
  if (json) {
    try {
      json = JSON.stringify(json)
    } catch {
      // json = json
    }
    return json
  }
  return ''
}

Vue.prototype.$StrToArray = function (str) {
  if (str) {
    if (typeof str === 'string') {
      try {
        str = str.substring(0, 1) === '[' ? JSON.parse(str) : []
      } catch {
        str = []
      }
      return str
    }
  }
  return []
}

Vue.prototype.$CSV = async function (file) {
  return await new Promise((resolve, reject) => {
    Papa.parse(file, {
      complete: (res) => {
        resolve(res)
      }
    })
  })
}

Vue.prototype.$isWeekend = function (date) {
  date = new Date(date)
  return date.getDay() % 6 === 0
}

Vue.prototype.$dateFromTo = function (fromTo) {
  if (fromTo) {
    if (fromTo.length === 2) {
      let result = null
      if ((new Date(fromTo[0])).getTime() < (new Date(fromTo[1])).getTime()) {
        result = [fromTo[0], fromTo[1]]
      } else {
        result = [fromTo[1], fromTo[0]]
      }
      if (result[0] === result[1]) {
        const dt = new Date(result[1])
        dt.setDate(dt.getDate() + 1)
        const dd = String(dt.getDate()).padStart(2, '0')
        const mm = String(dt.getMonth() + 1).padStart(2, '0')
        const yyyy = dt.getFullYear()
        result[1] = yyyy + '-' + mm + '-' + dd
      }
      return result
    }
  }
  return []
}

Vue.prototype.$Location = async function (_this) {
  if (!t && _this) {
    t = _this
  }
  // chrome://settings/content
  return new Promise(resolve => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError)
      navigator.geolocation.watchPosition(watchPosition)
      // navigator.geolocation.clearWatch()
    } else {
      resolve({
        err: true,
        data: 'Geolocation is not supported by this browser.'
      })
    }

    function watchPosition (position) {
      t.$store.dispatch('ME_UPDATE', {
        pos_lat: position.coords.latitude + '',
        pos_lng: position.coords.longitude + ''
      })
    }

    function showPosition (position) {
      resolve({
        err: false,
        data: {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      })
    }
  
    function showError (error) {
      let msg = ''
      switch(error.code) {
        case error.PERMISSION_DENIED:
          msg = 'User denied the request for Geolocation.'
          break
        case error.POSITION_UNAVAILABLE:
          msg = 'Location information is unavailable.'
          break
        case error.TIMEOUT:
          msg = 'The request to get user location timed out.'
          break
        case error.UNKNOWN_ERROR:
          msg = 'An unknown error occurred.'
          break
      }
      resolve({
        err: true,
        data: msg
      })
    }
  
  })
}

Vue.prototype.$area = function (id) {
  const a = this.$store.state.areas.find(r => parseInt(r.value) === parseInt(id))
  if (a) {
    return Object.assign({}, a)
  }
  return {}
}

Vue.prototype.$toGeoJSON = function (data, cb) {
  var outPut = {
    type: 'FeatureCollection',
    features: []
  }
  var fl = data.features.length
  var i = 0
  while (fl > i){
    var ft = data.features[i]
    /* as only ESRI based products care if all the features are the same type of geometry, check for geometry type at a feature level*/
    var outFT = {
      type: 'Feature',
      properties: ft.attributes
    }
    if (ft.geometry.x){
      //check if it's a point
      outFT.geometry=point(ft.geometry)
    } else if(ft.geometry.points){
      //check if it is a multipoint
      outFT.geometry=points(ft.geometry)
    } else if(ft.geometry.paths){
      //check if a line (or "ARC" in ESRI terms)
      outFT.geometry=line(ft.geometry)
    } else if(ft.geometry.rings){
      //check if a poly.
      outFT.geometry=poly(ft.geometry)
    }
    outPut.features.push(outFT)
    i++
  }

  function point (geometry) {
    // this one is easy
    return { type: 'Point', coordinates: [geometry.x,geometry.y] }  
  }
  function points (geometry) {
    //checks if the multipoint only has one point, if so exports as point instead
    if (geometry.points.length === 1) {
      return { type: 'Point', coordinates: geometry.points[0] }
    } else {
      return { type: 'MultiPoint', coordinates: geometry.points } 
    }
  }
  function line (geometry) {
    //checks if their are multiple paths or just one
    if(geometry.paths.length === 1) {
      return { type: 'LineString', coordinates: geometry.paths[0] }
    } else {
      return { type: 'MultiLineString', coordinates: geometry.paths }
    }
  }
  function poly (geometry) {
    //first we check for some easy cases, like if their is only one ring
    if (geometry.rings.length === 1) {
      return { type: 'Polygon', coordinates: geometry.rings }
    } else {
      /*if it isn't that easy then we have to start checking ring direction, basically the ring goes clockwise its part of the polygon, if it goes counterclockwise it is a hole in the polygon, but geojson does it by haveing an array with the first element be the polygons and the next elements being holes in it*/
      var ccc= dP(geometry.rings)
      var d = ccc[0]
      var dd = ccc[1]
      var r = []
      if (dd.length === 0) {
        /*if their are no holes we don't need to worry about this, but do need to stuck each ring inside its own array*/
        var l2 = d.length
        var i3 = 0
        while (l2 > i3) {
          r.push([d[i3]])   
        }
        return { type: 'MultiPolygon', coordinates: r } 
      } else if (d.length === 1) {
        /*if their is only one clockwise ring then we know all holes are in that poly*/
        dd.unshift(d[0])
        return { type: 'Polygon', coordinates: dd }
      } else {
        /*if their are multiple rings and holes we have no way of knowing which belong to which without looking at it specially, so just dump the coordinates and add  a hole field, this may cause errors*/
        return { type: 'MultiPolygon', coordinates: d, holes: dd }
      }  
    }
  }
  function dP (a) {
    //returns an array of 2 arrays, the first being all the clockwise ones, the second counter clockwise
    var d = []
    var dd = []
    var l = a.length
    var ii = 0
    while (l > ii) {
      if (c(a[ii])) {
        d.push(a[ii])
      } else {
        dd.push(a[ii])
      }
      ii++
    }
    return [d, dd]
  }
  function c (a) {
    //return true if clockwise
    var l = a.length - 1
    var i = 0
    var o = 0
    while (l > i) {
      o += (a[i][0] * a[i + 1][1] - a[i + 1][0] * a[i][1])
      i++
    }
    return o <= 0
  }
  if (cb) {
    cb(outPut)
  } else {
    return outPut
  }
}
